import React from 'react'

import { useTranslation } from 'react-i18next'
import camelCase from 'camelcase'

import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

export type SeparableSpaceFieldProps = FieldProps<BasicInfoScreenValidationResult> & SeparableSpaceFieldAdditionalProps

type SeparableSpaceFieldAdditionalProps = {
  separableSpaceType: SeparableSpaceType
}

export enum SeparableSpaceType {
  AREA = 'AREA',
  STORAGE_AND_PRODUCTION_AREA = 'STORAGE_AND_PRODUCTION_AREA',
  STORE_AREA = 'STORE_AREA',
}

const SeparableSpaceField: React.FC<SeparableSpaceFieldProps> = ({
  validationMessages,
  insertionData,
  screenName,
  separableSpaceType,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <TextInput
      id='separable-space'
      propertyName='separableSpace'
      placeholder=''
      label={
        <span>{t(`wizard.screen.basicInfo.separableSpace.${camelCase(separableSpaceType)}`, 'Separable space')}</span>
      }
      value={insertionData.separableSpace}
      maxLength={12}
      type='text'
      affixRight='unit'
      unitRight='sqm'
      errors={validationMessages?.separableSpace ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default SeparableSpaceField
